import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, ImageReveal } from "../shared/Reveal";
import { imgUrl } from "../../lib/api";
import { OP_STATUS } from "./operationsData";

export const Placeholder = ({ text, className = "", dark = false }) => (
  <div className={`relative overflow-hidden flex items-center justify-center ${dark ? "bg-ink" : "bg-beige/70"} ${className}`} data-testid="op-placeholder">
    <div className="absolute inset-0 opacity-[0.35]" style={{ backgroundImage: `repeating-linear-gradient(135deg, transparent 0 22px, ${dark ? "rgba(203,178,121,0.16)" : "rgba(31,35,38,0.06)"} 22px 23px)` }} />
    <div className={`absolute inset-6 md:inset-8 border ${dark ? "border-gold/30" : "border-ink/10"}`} />
    <div className="relative text-center px-8">
      <img src="/logo-mark.png" alt="" className={`h-10 md:h-12 mx-auto mb-5 ${dark ? "" : "opacity-70"}`} />
      <div className={`text-[11px] md:text-xs uppercase tracking-[0.25em] ${dark ? "text-cream/70" : "text-stone"}`}>{text}</div>
    </div>
  </div>
);

export const StatusBadge = ({ status, light = false }) => (
  <span data-testid="op-status-badge" className={`inline-flex items-center gap-2 text-[10px] md:text-[11px] uppercase tracking-[0.22em] px-4 py-2 border ${status === "aperta" ? (light ? "border-gold text-gold" : "border-sage text-sage bg-sage/10") : light ? "border-cream/40 text-cream/80" : "border-ink/20 text-stone"}`}>
    {status === "aperta" && <span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" />}{OP_STATUS[status] || status}
  </span>
);

export const OperationCard = ({ o, index = 0 }) => (
  <Reveal delay={index * 0.1} data-testid={`operation-card-${o.slug}`} className="group bg-white border border-ink/10 hover:border-gold/60 transition-colors duration-500 flex flex-col">
    <Link to={`/operazioni/${o.slug}`} className="block">
      {o.cover_image && o.cover_full_graphic ? <img src={imgUrl(o.cover_image)} alt={`${o.title} — ${o.location || o.city}`} className="w-full aspect-video object-contain bg-cream" loading="lazy" /> : o.cover_image ? <ImageReveal src={imgUrl(o.cover_image)} alt={`${o.title} — ${o.location || o.city}`} className="aspect-[16/10] bg-beige" /> : <Placeholder text="Immagini in aggiornamento" className="aspect-[16/10]" />}
    </Link>
    <div className="p-8 md:p-10 flex flex-col flex-1">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="eyebrow !text-stone">{o.location || o.city}</div>
        <StatusBadge status={o.status} />
      </div>
      <h3 className="h-card mt-5 uppercase tracking-wide">{o.title}</h3>
      {o.summary && <p className="text-sm md:text-base font-light text-ink/70 leading-relaxed mt-4">{o.summary}</p>}
      {o.strategy && <div className="mt-6"><div className="label-line">Strategia</div><div className="text-sm font-light">{o.strategy}</div></div>}
      <Link to={`/operazioni/${o.slug}`} data-testid={`operation-cta-${o.slug}`} className="btn-link mt-8 self-start group-hover:text-gold group-hover:border-gold">Scopri l'operazione <ArrowRight size={14} /></Link>
    </div>
  </Reveal>
);
